export default {
  gestureHandling: {
    type: String,
    default: 'greedy',
  },
  directionToZoom: {
    type: String,
    default: null,
  },
  gmapCenter: {
    type: Object,
    default: () => ({
      lat: 32.896962,
      lng: 13.186619,
    }),
  },
  gmapZoom: {
    type: Number,
    default: 3,
  },
  userMarkerChangesZoom: {
    type: Boolean,
    default: false,
  },
  userMarkerAnimated: {
    type: Boolean,
    default: false,
  },
};
